import { Navigate, Outlet } from "react-router-dom";

const ProtectedRoute = ({ allowedRole }) => {
  const userType = localStorage.getItem("userType");

  // Not logged in OR wrong role
  if (!userType || (allowedRole && userType !== allowedRole)) {
    return <Navigate to="/users/login" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
